import { render, staticRenderFns } from "./updateExtrinsicFactorsNode.vue?vue&type=template&id=4bc1acbf&scoped=true&"
import script from "./updateExtrinsicFactorsNode.vue?vue&type=script&lang=js&"
export * from "./updateExtrinsicFactorsNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1acbf",
  null
  
)

export default component.exports